import React, { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import mdDocs from '../../../docs/index.md'
import { generateSlug } from './utils'
import { DocsMenu } from './DocsMenu'
import './styles.css'
import { CardImg } from 'reactstrap'

export const DocsPage = () => {

    const [page, setPage] = useState(null)
    const logo = require('@src/assets/images/backgrounds/logo-white.png').default
    useEffect(() => {
        fetch(mdDocs).then((mdDocs) => mdDocs.text()).then((mdDocs) => setPage(mdDocs))
    }, [])

    return (
        <div className='h-100 w-100 d-flex justify-content-between'>
            <div className='w-20 vh-100 px-2  menu-md ' style={{ width: '20%' }}>
                <div style={{ maxHeight: '100px', maxWidth: '150px' }}>
                    <CardImg src={logo} style={{ width: '115%' }} />
                </div>
                <hr />
                <DocsMenu className=" " />
            </div>
            <div className='d-flex justify-content-center vh-100' style={{ overflowY: 'scroll', width: '80%' }}>
                <div className='md-document'>
                    <ReactMarkdown
                        // remarkPlugins={[remarkGfm]}
                        components={{
                            h1: ({ node, ...props }) => (
                                <h1 className='pt-1' id={generateSlug(props.children[0])} {...props}></h1>
                            ),
                            h2: ({ node, ...props }) => (
                                <h2 className='pt-1' id={generateSlug(props.children[0])} {...props}></h2>
                            ),
                            h3: ({ node, ...props }) => (
                                <h3 className='pt-1' id={generateSlug(props.children[0])} {...props}></h3>
                            ),
                            h4: ({ node, ...props }) => (
                                <h4 className='pt-1' id={generateSlug(props.children[0])} {...props}></h4>
                            ),
                            h5: ({ node, ...props }) => (
                                <h5 className='pt-1' id={generateSlug(props.children[0])} {...props}></h5>
                            ),
                            h6: ({ node, ...props }) => (
                                <h6 className='pt-1' id={generateSlug(props.children[0])} {...props}></h6>
                            ),
                            p: ({ node, ...props }) => (
                                <p className='text-justify' id={generateSlug(props.children[0])} {...props}></p>
                            ),
                        }}
                    >{page}</ReactMarkdown>
                </div>
            </div>
        </div >
    )
}
